import { type VariantProps, tv } from "tailwind-variants";
import Root from "./radio-button-group.svelte";
import Button from "./radio-button.svelte";
import { getContext, setContext } from "svelte";

export const radioButtonVariants = tv({
    base: "hover:bg-muted hover:text-muted-foreground focus-visible:ring-ring inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 [&:has(button:disabled)]:pointer-events-none [&:has(button:disabled)]:opacity-50 mb-0",
    variants: {
        variant: {
            default: "bg-transparent",
            outline: "border-input hover:bg-accent hover:text-accent-foreground border bg-transparent shadow-sm",
        },
        selectVariant: {
            default: "[&:has(button[data-state='checked'])]:bg-accent [&:has(button[data-state='checked'])]:text-accent-foreground",
            primary: "[&:has(button[data-state='checked'])]:bg-primary [&:has(button[data-state='checked'])]:text-primary-foreground [&:has(button[data-state='checked'])]:border-primary",
        },
        size: {
            default: "h-9 px-3",
            sm: "h-8 px-2",
            lg: "h-10 px-3",
        },
        grouped: {
            true: "rounded-none first:rounded-l-md last:rounded-r-md",
        }
    },
    defaultVariants: {
        variant: "default",
        selectVariant: "default",
        size: "default",
        grouped: false,
    },
});

export type RadioButtonVariants = VariantProps<typeof radioButtonVariants>;

export function setRadioButtonGroupCtx(props: RadioButtonVariants ) {
    setContext("radioButtonGroup", props);
}

export function getRadioButtonGroupCtx() {
    return getContext<RadioButtonVariants >("radioButtonGroup");
}

export {
    Root,
    Button,
    //
    Root as RadioButtonGroup,
    Button as RadioButton,
};